import React from 'react';
import { DeleteOutline, MoreVertRounded } from '@mui/icons-material';
import TooltipIconButton from "components/TooltipIconButton";
import SidebarHeader from '../../layout/SidebarHeader';

// import ButtonIcon from '../../../ButtonIcon';

const Header = ({ onClose }) => (
  // TO DO - add delete + more menu functionality
  <SidebarHeader onClose={onClose}>
    {/* <TooltipIconButton title="Delete" ariaLabel="delete" placement="bottom" onClick={onClose} size={44}>
      <DeleteOutline />
    </TooltipIconButton>     */}
    {/* <ButtonIcon noBg><MoreVertRounded /></ButtonIcon> */}
  </SidebarHeader>
)

export default Header;